<section class="bg-white">
  <div class="grid lg:h-screen lg:grid-cols-2">
    <div class="flex items-center justify-center px-4 py-6 lg:py-0 sm:px-0">
      <form class="w-full max-w-md space-y-4 md:space-y-6 xl:max-w-xl" [formGroup]="loginForm" (ngSubmit)="signIn()">
        <h1 class="text-xl font-bold text-gray-900">
          Sign in to your account
        </h1>

        <ng-container *ngIf="errorMessage">
          <div class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50" role="alert">
            <span class="font-medium">Alert:</span> {{ errorMessage }}
          </div>
        </ng-container>

        <div>
          <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Email</label>
          <input type="email" formControlName="email" name="email" id="email"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-4"
            placeholder="Enter your email" required="" autocomplete="email">
          <div *ngIf="loginForm.get('email')?.hasError('required') && loginForm.get('email')?.touched"
            class="text-red-500 text-xs font-medium mt-2">
            Email is required
          </div>
          <div *ngIf="loginForm.get('email')?.hasError('email') && loginForm.get('email')?.touched"
            class="text-red-500 text-xs font-medium mt-2">
            Invalid email format
          </div>
        </div>
        <div class="relative">
          <label for="password" class="block mb-2 text-sm font-medium text-gray-900">Your password</label>
          <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" name="password"
            id="password"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-4"
            required autocomplete="new-password">
          <button type="button" class="w-6 h-6 text-gray-800 absolute top-11 right-3 cursor-pointer"
            (click)="togglePasswordVisibility()">
            <svg class="flex-shrink-0 size-4 text-blue-800 dark:text-white" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <!-- Eye icon when password is hidden -->
              <path *ngIf="!isPasswordVisible" stroke="currentColor" d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
              <path *ngIf="!isPasswordVisible" stroke="currentColor"
                d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
              <path *ngIf="!isPasswordVisible" stroke="currentColor"
                d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
              <line *ngIf="!isPasswordVisible" x1="2" x2="22" y1="2" y2="22"></line>

              <!-- Eye icon when password is visible -->
              <path *ngIf="isPasswordVisible" stroke="currentColor" d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z">
              </path>
              <circle *ngIf="isPasswordVisible" cx="12" cy="12" r="3"></circle>
            </svg>
          </button>
          <div *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched"
            class="text-red-500 text-xs font-medium mt-2">
            Password is required
          </div>
          <div *ngIf="loginForm.get('password')?.hasError('minlength') && loginForm.get('password')?.touched"
            class="text-red-500 text-xs font-medium mt-2">
            Password must be at least 8 characters long
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input id="remember" aria-describedby="remember" type="checkbox"
                class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300"
                required="">
            </div>
            <div class="ml-3 text-sm">
              <label for="remember" class="text-gray-500">Remember me</label>
            </div>
          </div>
          <a (click)="routeChange('auth/forgot-password')"
            class="pointer text-sm font-medium text-primary-600 hover:underline">Forgot password?</a>
        </div>
        <button [disabled]="loginForm.invalid" type="submit"
          [ngClass]="{'cursor-not-allowed bg-primary-950': loginForm.invalid,
          'cursor-pointer bg-primary-500 hover:bg-primary-500': loginForm.valid,
          'flex flex-row items-center justify-center text-center w-full text-white font-medium rounded-lg text-sm px-5 py-3': true}">

          <ng-container *ngIf="!isLoading">Sign in to your account</ng-container>

          <ng-container *ngIf="isLoading">
            <svg aria-hidden="true" class="w-6 h-6 text-gray-200 animate-spin fill-primary-600" viewBox="0 0 100 101"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
            </svg>
            <span class="sr-only">Loading...</span>
          </ng-container>
        </button>
        <p class="text-sm font-light text-gray-500">
          Don't have an account? <a (click)="routeChange('auth/register')"
            class="pointer font-medium text-primary-600 hover:underline">Sign up</a>
        </p>
      </form>
    </div>
    <div class="hidden mx-auto lg:flex items-center justify-center px-4 py-6 bg-gray-200 lg:py-0 sm:px-4">
      <div class="">
        <img src="assets/images/login-banner.svg" alt="illustration" class="">
      </div>
    </div>
  </div>
</section>